export const NAMESPACE = 'KanBo/descendantBlockedCards/'
export const ADD = NAMESPACE + 'ADD'
export const SET_ARRAY = NAMESPACE + 'SET_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = {}

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.cardId]: Array.from(new Set<number>(state[action.payload.cardId]).add(action.payload.descendantCardId)),
      }
    case SET_ARRAY:
      return {
        ...state,
        [action.payload.cardId]: Array.from(new Set<number>(action.payload.descendantCardIds)),
      }
    case REMOVE:
      return state[action.payload.cardId]?.includes(action.payload.descendantCardId) ? {
        ...state,
        [action.payload.cardId]: state[action.payload.cardId].filter(id => id !== action.payload.descendantCardId),
      } : state
    default: return state
  }
}

export function add ({ cardId, descendantCardId }) {
  return {
    type: ADD,
    payload: {
      cardId,
      descendantCardId,
    }
  }
}

export function setArray ({ cardId, descendantCardIds }) {
  return {
    type: SET_ARRAY,
    payload: {
      cardId,
      descendantCardIds,
    }
  }
}

export function remove ({ cardId, descendantCardId }) {
  return {
    type: REMOVE,
    payload: {
      cardId,
      descendantCardId,
    }
  }
}
